import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useLessonList = (params?: any) => {
  return useQuery({
    queryKey: ['lesson-list', params],
    queryFn: async () => {
      const res = await request.get('/lesson/admin', { params });
      return res.data;
    }
  });
};
